import { DateView, DesktopDatePicker, LocalizationProvider, ptBR } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import React from 'react'
import { Control, Controller } from 'react-hook-form'

type TextFieldDatePickerProps = {
  label: string
  value?: any
  name: string
  minDate?: any
  views?: DateView[]
  control: Control<any>
  disabled?: boolean
  enableFuture?: boolean
  disablePast?: boolean
  required?: boolean
  readonly?: boolean
}

const FormInputDatePicker: React.FC<TextFieldDatePickerProps> = ({
  name,
  label,
  minDate,
  views,
  control,
  disabled,
  enableFuture,
  disablePast,
  required = false,
  readonly,
}) => {
  const convertValue = (value?: any) => {
    if (!value) return null
    const date = dayjs(value)
    return date.isValid() ? date : null
  }

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale='pt-br'
          localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
        >
          <DesktopDatePicker
            label={label}
            format={!views ? 'DD/MM/YYYY' : undefined}
            value={convertValue(value)}
            onChange={(date) => {
              onChange(date ? dayjs(date).format('YYYY-MM-DD') : null)
            }}
            slotProps={{
              textField: {
                size: 'small',
                fullWidth: true,
                name,
                error: !!error?.message,
                helperText: error?.message,
                required,
              },
            }}
            readOnly={readonly}
            localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}
            minDate={convertValue(minDate)}
            disableFuture={!enableFuture}
            disablePast={disablePast}
            views={views}
            disabled={disabled}
          />
        </LocalizationProvider>
      )}
    />
  )
}

export default FormInputDatePicker
